function InternalServerError() {
    return (
        <div>
            <h1>Internal Server Error</h1>
            <p>Please try again.</p>
        </div>
    );
}

export default InternalServerError;